export type ApiNotice = {
  /** Stable key for the dismissal record in localStorage. Never reuse it. */
  id: string;
  body: string;
};

const SPOTIFY_CREATE_NOTICE: ApiNotice = {
  id: 'spotify-tools-write-limits',
  body: 'You can preview a playlist here. Saving it to your Spotify account needs an approved login.',
};

const SPOTIFY_UPDATE_NOTICE: ApiNotice = {
  id: 'spotify-tools-write-limits',
  body: 'You can find duplicates on a public playlist. Removing them from your playlist needs an approved login.',
};

const TWITTER_NOTICE: ApiNotice = {
  id: 'twitter-api-suspension',
  body:
    'X now charges $100 per month for API access, so my key is suspended. These tools cannot load new tweets, and the chat cannot answer as a person.',
};

/** Tools that create a new Spotify playlist. Read-only tools get no banner. */
const SPOTIFY_CREATE_PATHS = [
  '/discover',
  '/sets',
  '/set-playlist',
  '/filter',
  '/djsets',
  '/dj-sets-playlist',
  '/segments',
];

const SPOTIFY_UPDATE_PATHS = ['/dupes'];

const TWITTER_PATHS = ['/twitter', '/tweetgpt'];

function buildNoticeByPath(): Record<string, ApiNotice> {
  const byPath: Record<string, ApiNotice> = {};
  for (const path of SPOTIFY_CREATE_PATHS) {
    byPath[path] = SPOTIFY_CREATE_NOTICE;
  }
  for (const path of SPOTIFY_UPDATE_PATHS) {
    byPath[path] = SPOTIFY_UPDATE_NOTICE;
  }
  for (const path of TWITTER_PATHS) {
    byPath[path] = TWITTER_NOTICE;
  }
  return byPath;
}

const NOTICE_BY_PATH = buildNoticeByPath();

export function getApiNotice(pathname: string): ApiNotice | undefined {
  const normalized =
    pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
  return NOTICE_BY_PATH[normalized];
}
